import React, { KeyboardEventHandler, MouseEventHandler } from "react";
import SendButton from "../../assets/images/fi-rr-paper-plane.svg";
import "../../css/chats.css";

type MessageSendPropsType = {
  onMessageSend: (
    event:
      | React.MouseEvent<HTMLDivElement>
      | React.KeyboardEvent<HTMLDivElement>
  ) => void;
};

function MessageSendButton(props: MessageSendPropsType) {
  const { onMessageSend } = props;
  return (
    <div onClick={onMessageSend}>
      <img className="tasd-img-input-div__send-btn" src={SendButton} />
    </div>
  );
}

export default MessageSendButton;
